export const queryKeys = {
  tenants: {
    all: ['tenants'] as const,
  },
  agents: {
    all: ['agents'] as const,
    pending: ['agents', 'pending'] as const,
    // Rows in another lifecycle status (e.g. 'rejected'). Shares the 'pending' prefix so a
    // single invalidateQueries(queryKeys.agents.pending) refreshes every tab.
    pendingByStatus: (status: string) => ['agents', 'pending', status] as const,
  },
  alarms: {
    all: ['alarms'] as const,
    subscription: (cameraId: string) =>
      ['alarms', 'subscription', cameraId] as const,
    subscriptions: () => ['alarms', 'subscriptions'] as const,
    events: (filters?: Record<string, unknown>) =>
      ['alarms', 'events', filters] as const,
  },
  ptz: {
    all: ['ptz'] as const,
    control: (cameraId: string) => ['ptz', 'control', cameraId] as const,
    presets: (cameraId: string) => ['ptz', 'presets', cameraId] as const,
  },
} as const;
